import axios from 'axios';
import { apiGateway } from 'src/config';
import { EnqueteThreadPriorInfo } from './getThreadCreatorApi';
import { fetchAuthSession } from 'aws-amplify/auth';

export interface EnqueteThreadEditor {
  title: string;
  surveyDetailId: string;
  isPrivate: boolean;
  isSendMailToUser: boolean;
  description: string;
  categories: string[];
  threadUsers: string[];
}

export const getThreadEditorApi = () => {
  const getBearerToken = async () => {
    const token = (await fetchAuthSession()).tokens?.idToken?.toString();
    return `Bearer ${token}`;
  };

  const getThreadPriorInfo = async () => {
    const token = await getBearerToken();
    const response = await axios.get<EnqueteThreadPriorInfo>(apiGateway + '/enquete-threads/create', {
      headers: {
        Authorization: token,
      },
      timeout: 60000,
    });
    return response.data;
  };

  const editThread = async (data: EnqueteThreadEditor, threadId: string) => {
    try {
      const token = await getBearerToken();
      const result = await axios.put<EnqueteThreadEditor>(apiGateway + `/enquete-threads/${threadId}`, data, {
        headers: { Authorization: token },
        params: { threadId: threadId },
        timeout: 60000,
      });
      return result.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw error.response?.status;
      } else {
        throw error;
      }
    }
  };

  return { getThreadPriorInfo, editThread };
};
